import React, { useContext } from 'react';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';
import { ProductTransaction, ProductTransactionType } from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../../types/product_master_data/productMasterData';
import { t } from '../../../../../../../../types/translation/Translator';
import { ProductContext } from '../../../../../../../../context/ProductContext';
import { Container } from '../../../../../../../../types/container';
import { DropdownSearchSelect } from '../../../../../../../components/Dropdown';

interface ProductTransactionSourceSerialProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  productMasterData?: ProductMasterData;
  container?: Container;

  disabled?: boolean;
}

export default function ProductTransactionSourceSerial({
  transaction,
  setTransaction,
  productMasterData,
  container,
  disabled = false,
}: ProductTransactionSourceSerialProps) {
  if (!productMasterData) return null;

  const { products } = useContext(ProductContext);

  if (!productMasterData.serialManaged) return null;
  if (transaction.type === ProductTransactionType.inbound) return null;

  const serialProducts = [...(products.get(transaction.product.pmdId || '')?.values() || [])].filter(
    el =>
      el.serial &&
      el.companyId === transaction.companyId &&
      (!transaction.product.fromStockLocationId || el.stockLocationId === transaction.product.fromStockLocationId) &&
      (!transaction.product.fromBinId || el.binId === transaction.product.fromBinId),
  );

  const selected = serialProducts.find(p => p.serial === transaction.product.serialNbr);

  return (
    <Grid item xs={6}>
      <DropdownSearchSelect
        mandatory
        disabled={disabled}
        label={t(TranslationKey.serial).singular.label}
        placeholder={t(TranslationKey.serial).singular.label}
        items={serialProducts}
        onSelect={product => {
          let updated = transaction.withSerial(product?.serial);
          if (product) updated = updated.withFromBinId(product.binId).withFromContainerId(product.containerId);
          setTransaction(updated);
        }}
        value={selected}
        textBuilder={product => product?.serial || ''}
      />
    </Grid>
  );
}
